export default "__VITE_ASSET__D_TpM6ix__"